import * as core from '../../../../../../../core'

import { query } from './anticipated-response-of-change.query'

export const RESOURCE = {
  payload: {
    alias: 'anticipated.response.of.change',
    description:
      'Bar chart of change impacts by anticipated response of change',
    name: 'Anticipated Response of Change',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
